<template>
  <div v-if="order[checkpoint]">
    <strong>
      <b-badge :id="'tooltip-target-' + rnd">
        <i class='fas fa-eye'></i>
      </b-badge>
      <b-tooltip :target="'tooltip-target-' + rnd" triggers="hover" custom-class="tooltip-with-map-md"
        boundary-padding="20">
        <div class="text-left">
          <shipping-order-map :orders="[order]" :only-checkpoint="checkpoint" :radius-list="[0.5, 1, 3, 5]"
            :radius-default="0.5" style="height: 550px; width: 550px" />
        </div>
      </b-tooltip>
      {{ order[checkpoint].name | cleanentityprefix }}
    </strong>
    <div><small>({{ order[checkpoint].city }})</small></div>
    <div class="text-nowrap"><small>{{ order[checkpoint + '_location'] | cleanentityprefix }}</small></div>

    <b-badge :variant="order[checkpoint].items_count ? 'info' : 'dark'"
      v-translate="{ count: order[checkpoint].items_count || 0 }" :translate-n="order[checkpoint].items_count || 0"
      translate-plural="%{ count } items">%{ count } item</b-badge>
  </div>
</template>

<script>
import ShippingOrderMap from '@/components/Maps/ShippingOrderMap'

export default {
  name: 'ShippingOrdersListItemExternalId',
  components: {
    ShippingOrderMap
  },
  props: {
    order: {
      type: Object,
      default: () => { },
      required: true
    },
    checkpoint: {
      type: String,
      default: 'origin'
    }
  },
  data() {
    return {
      rnd: Math.random()
    }
  }
}
</script>

<style lang="scss">
.tooltip-with-map-md {
  padding: 30px;
  width: 565px;
  height: 565px;
  z-index: 1040 !important;

  .tooltip-inner {
    max-width: none !important;
  }
}
</style>
